<template>
  <BaseFinancialStatementSnapshot docType="BALANCE_SHEET" />
</template>

<script>
import BaseFinancialStatementSnapshot from '@/component/BaseFinancialStatementSnapshot.vue'

export default {
  name: 'BalanceSheetList',
  components: { BaseFinancialStatementSnapshot },
}
</script>
